export const prefixAllow = ['WK89', 'LEXY88', '1XHENG', 'VK789', 'LK789', 'ALD88', 'K88', 'CB988', 'AT77', 'OD911', 'TH44']